/**
 * orderInternalMapper.js
 * Adapter: chuyển dữ liệu từ store main_order sang view model cho OrderList.
 *
 * Ghi chú về trạng thái của từng trường:
 * - Trường THỰC: lấy trực tiếp từ API response.
 * - Trường MOCK: đánh dấu rõ, trả placeholder/default. Khi backend bổ sung, chỉ cần sửa hàm này.
 */

/**
 * @param {Object} order - item từ state.main_order.all.data
 * @returns {Object} row view model dùng trong OrderList
 */
export function mapOrderToInternalRow(order) {
  const pendingComplainCount = Number(order.PendingComplainCount || 0);
  const totalComplainCount = Number(order.TotalComplainCount || 0);
  return {
    ...order,
    DisplayId: `MD${order.ID}`,
    OrderUrl: `/don-hang/${order.ID}`,
    RemainAmount: (order.TotalAmountVND || 0) - (order.Deposit || 0),
    PendingComplainCount: pendingComplainCount,
    TotalComplainCount: totalComplainCount,
    HasPendingComplain: pendingComplainCount > 0,
  };
}

export function getOrderShopLabel(order) {
  const shopName = (order && order.ShopName ? String(order.ShopName) : '').trim();
  if (shopName) {
    return shopName;
  }

  const site = (order && order.Site ? String(order.Site) : '').trim();
  return site ? `Shop-${site}` : 'Shop';
}

/**
 * Trả về nhãn timeline để render list lịch sử theo thứ tự.
 */
export const TIMELINE_LABELS = [
  { key: 'CreatedDate',     label: 'Lên đơn' },
  { key: 'DepositDate',     label: 'Cọc đơn' },
  { key: 'WaitBoughtDate',   label: 'Chờ mua' },
  { key: 'WaitPayment2Date', label: 'Chờ TT lần 2' },
  { key: 'BoughtDate',       label: 'Đã mua' },
  { key: 'ShopDeliverDate', label: 'Shop phát' },
  { key: 'StoreCNImDate',   label: 'Đến kho TQ' },
  { key: 'StoreCNExDate',   label: 'Xuất kho TQ' },
  { key: 'StoreVNImDate',   label: 'Nhập kho VN' },
  { key: 'StoreVNExDate',   label: 'Xuất kho VN' },
  { key: 'CompletedDate',   label: 'Hoàn thành' },
];

/**
 * Nhãn timeline chứng từ (MOCK).
 */
export const CONTRACT_HISTORY_LABELS = [
  'HĐ Nháp',
  'Hóa Đơn VAT',
  'Trả Hợp Đồng',
  'Nhận/Lưu HĐ',
];
